import { useLenis } from "lenis/react";
import { ArrowRight, FileText } from "lucide-react";
import { Reveal, SectionHead } from "../components/Reveal";

export default function Pricing({ content }) {
  const lenis = useLenis();
  const goBooking = (e) => {
    e.preventDefault();
    lenis?.scrollTo("#booking", { offset: -64, duration: 1.4 });
  };

  return (
    <section id="pricing" className="scroll-mt-20 py-24 sm:py-32" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          overline="Pricing"
          title="Clear starting prices. No surprises."
        />
        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {content.services.map((s, i) => (
            <Reveal key={s.id || i} delay={i * 0.08}>
              <article
                className="group h-full border border-white/10 bg-coal p-8 flex flex-col hover:border-electric/60 transition-colors"
                data-testid={`pricing-card-${s.id}`}
              >
                <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-gray-500">{s.tagline}</p>
                <h3 className="mt-3 font-display text-2xl font-semibold uppercase tracking-tight text-white">{s.title}</h3>
                <p className="mt-6 font-display text-4xl sm:text-5xl font-bold text-electric-bright tracking-tight" data-testid={`pricing-price-${s.id}`}>
                  {s.price}
                </p>
                <ul className="mt-6 space-y-2 flex-1">
                  {s.points?.map((p, j) => (
                    <li key={j} className="text-sm text-gray-400 flex items-start gap-2">
                      <span className="mt-[7px] h-1 w-1 bg-electric-bright shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
                <a
                  href="#booking"
                  onClick={goBooking}
                  data-testid={`pricing-book-${s.id}`}
                  className="mt-8 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-white group-hover:text-electric-bright transition-colors"
                >
                  Book this service <ArrowRight size={14} />
                </a>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-5 border border-white/10 bg-gradient-to-r from-coal to-surface p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center gap-6 justify-between" data-testid="pricing-quote-banner">
            <div className="flex items-start gap-4">
              <span className="h-11 w-11 shrink-0 border border-electric/40 flex items-center justify-center text-electric-bright">
                <FileText size={18} />
              </span>
              <div>
                <h3 className="font-display text-xl sm:text-2xl font-semibold uppercase tracking-tight text-white">
                  Need an individual assessment?
                </h3>
                <p className="mt-2 text-sm text-gray-400 leading-relaxed max-w-2xl">{content.pricing_note}</p>
              </div>
            </div>
            <a
              href="#booking"
              onClick={goBooking}
              data-testid="pricing-quote-button"
              className="shrink-0 bg-electric hover:bg-electric-bright text-white text-xs font-bold uppercase tracking-[0.2em] px-7 py-4 transition-colors shadow-[0_0_22px_rgba(6,69,243,0.35)]"
            >
              Request a Quote
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
